import { types, Instance, SnapshotIn, getParent } from "mobx-state-tree";
import { questionChoices } from "../Components/Enums/TitleEnums";

export const AssessmentQuestion = types
  .model("Question", {
    key: types.string,
    timeToComplete: types.maybeNull(types.string),
    question: types.string,
    answer: types.maybeNull(types.string),
    dependsOnQuestionKey: types.maybe(types.string),
    dependsOnAnswer: types.maybe(types.string),
    taskName: types.maybeNull(types.string),
  })
  .actions((self) => ({
    setAnswer: (answer: string) => {
      self.answer = answer;
      (getParent(self, 5) as any).saveCaregiver();
    },
    setTimeToComplete: (timeToComplete: string) => {
      self.timeToComplete = timeToComplete;
    },
  }))
  .views((self) => ({
    get isAnswered() {
      return self.answer === questionChoices.YES || self.answer === questionChoices.DNA;
    },
    get priority() {
      switch (self.timeToComplete) {
        case "Very Important":
          return 1;
        case "Important":
          return 2;
        case "Less Important":
          return 3;
        case "Not Important":
          return 4;
        default:
          return 5;
      }
    },
  }));

export default AssessmentQuestion;
export interface IAssessmentQuestionSnapshotIn
  extends SnapshotIn<typeof AssessmentQuestion> { }
export interface IAssessmentQuestion
  extends Instance<typeof AssessmentQuestion> { }
